var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"icon":"","small":"","disabled":_vm.disabled},on:{"click":_vm.copy}},[_c('v-icon',{attrs:{"small":""}},[_vm._v(_vm._s(_vm.icon))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }